import { Outlet } from "react-router-dom";
import { SectionSidebarNav } from "@/components/SectionSidebarNav";
import { useVisibleAuswertungenNavItems } from "@/lib/auswertungenNav";

export function AuswertungenLayout() {
  const navItems = useVisibleAuswertungenNavItems();
  return (
    <div className="eh-bestellwesen-page-shell">
      <SectionSidebarNav items={navItems} ariaLabel="Auswertungen" />
      <div className="eh-project-page-main">
        <Outlet />
      </div>
    </div>
  );
}
